<script setup lang="ts">
  /* eslint-disable */
  // @ts-nocheck
  import { ref, onMounted, onUnmounted, nextTick } from 'vue';

  const Confetti = (function () {
    var t = (function () {
        return function () {
          ((this.gravity = 10),
            (this.particle_count = 75),
            (this.particle_size = 1),
            (this.explosion_power = 25),
            (this.destroy_target = !0),
            (this.fade = !1),
            (this.y_bias = -0.7));
        };
      })(),
      e = (function () {
        function e(n) {
          const r = this;
          if (
            ((this.bursts = []),
            (this.setCount = function (t) {
              if (typeof t !== 'number') {
                throw new Error("Input must be of type 'number'");
              }
              e.CONFIG.particle_count = t;
            }),
            (this.setPower = function (t) {
              if (typeof t !== 'number') {
                throw new Error("Input must be of type 'number'");
              }
              e.CONFIG.explosion_power = t;
            }),
            (this.setSize = function (t) {
              if (typeof t !== 'number') {
                throw new Error("Input must be of type 'number'");
              }
              e.CONFIG.particle_size = t;
            }),
            (this.setFade = function (t) {
              if (typeof t !== 'boolean') {
                throw new Error("Input must be of type 'boolean'");
              }
              e.CONFIG.fade = t;
            }),
            (this.destroyTarget = function (t) {
              if (typeof t !== 'boolean') {
                throw new Error("Input must be of type 'boolean'");
              }
              e.CONFIG.destroy_target = t;
            }),
            (this.setYBias = function (t) {
              if (typeof t !== 'number') {
                throw new Error("Input must be of type 'number'");
              }
              e.CONFIG.y_bias = t;
            }),
            (this.setupCanvasContext = function () {
              if (!e.CTX) {
                const t = document.createElement('canvas');
                ((e.CTX = t.getContext('2d')),
                  (t.width = 2 * window.innerWidth),
                  (t.height = 2 * window.innerHeight),
                  (t.style.position = 'fixed'),
                  (t.style.top = '0'),
                  (t.style.left = '0'),
                  (t.style.width = 'calc(100%)'),
                  (t.style.height = 'calc(100%)'),
                  (t.style.margin = '0'),
                  (t.style.padding = '0'),
                  (t.style.zIndex = '999999999'),
                  (t.style.pointerEvents = 'none'),
                  document.body.appendChild(t),
                  window.addEventListener('resize', function () {
                    ((t.width = 2 * window.innerWidth), (t.height = 2 * window.innerHeight));
                  }));
              }
            }),
            (this.setupElement = function (t) {
              let n;
              ((r.element = document.getElementById(t)),
                (n = r.element) === null ||
                  void 0 === n ||
                  n.addEventListener('click', function (t) {
                    const n = new o(2 * t.clientX, 2 * t.clientY);
                    r.bursts.push(new i(n));
                    if (!r.animationId) {
                      r.time = performance.now();
                      r.animationId = window.requestAnimationFrame(r.update);
                    }
                    e.CONFIG.destroy_target && (r.element.style.visibility = 'hidden');
                  }));
            }),
            (this.animationId = null),
            (this.update = function (t) {
              ((r.delta_time = (t - r.time) / 1e3), (r.time = t));
              for (let e = r.bursts.length - 1; e >= 0; e--) {
                (r.bursts[e].update(r.delta_time),
                  r.bursts[e].particles.length == 0 && r.bursts.splice(e, 1));
              }
              r.draw();
              if (r.bursts.length > 0) {
                r.animationId = window.requestAnimationFrame(r.update);
              } else {
                r.animationId = null;
                s.clearScreen();
              }
            }),
            !n)
          ) {
            throw new Error('Missing id');
          }
          (e.CONFIG || (e.CONFIG = new t()),
            (this.time = new Date().getTime()),
            (this.delta_time = 0),
            this.setupCanvasContext(),
            this.setupElement(n));
        }
        return (
          (e.prototype.draw = function () {
            s.clearScreen();
            for (let t = 0, e = this.bursts; t < e.length; t++) {
              e[t].draw();
            }
          }),
          e
        );
      })(),
      i = (function () {
        function t(t) {
          this.particles = [];
          for (let i = 0; i < e.CONFIG.particle_count; i++) {
            this.particles.push(new n(t));
          }
        }
        return (
          (t.prototype.update = function (t) {
            for (let e = this.particles.length - 1; e >= 0; e--) {
              (this.particles[e].update(t),
                this.particles[e].checkBounds() && this.particles.splice(e, 1));
            }
          }),
          (t.prototype.draw = function () {
            for (let t = this.particles.length - 1; t >= 0; t--) {
              this.particles[t].draw();
            }
          }),
          t
        );
      })(),
      n = (function () {
        function t(t) {
          ((this.size = new o(
            (16 * Math.random() + 4) * e.CONFIG.particle_size,
            (4 * Math.random() + 4) * e.CONFIG.particle_size,
          )),
            (this.position = new o(t.x - this.size.x / 2, t.y - this.size.y / 2)),
            (this.velocity = r.generateVelocity()),
            (this.rotation = 360 * Math.random()),
            (this.rotation_speed = 10 * (Math.random() - 0.5)),
            (this.hue = 360 * Math.random()),
            (this.opacity = 100),
            (this.lifetime = Math.random() + 0.25));
        }
        return (
          (t.prototype.update = function (t) {
            ((this.velocity.y +=
              e.CONFIG.gravity * (this.size.y / (10 * e.CONFIG.particle_size)) * t),
              (this.velocity.x += 25 * (Math.random() - 0.5) * t),
              (this.velocity.y *= 0.98),
              (this.velocity.x *= 0.98),
              (this.position.x += this.velocity.x),
              (this.position.y += this.velocity.y),
              (this.rotation += this.rotation_speed),
              e.CONFIG.fade && (this.opacity -= this.lifetime));
          }),
          (t.prototype.checkBounds = function () {
            return this.position.y - 2 * this.size.x > 2 * window.innerHeight;
          }),
          (t.prototype.draw = function () {
            s.drawRectangle(this.position, this.size, this.rotation, this.hue, this.opacity);
          }),
          t
        );
      })(),
      o = (function () {
        return function (t, e) {
          ((this.x = t || 0), (this.y = e || 0));
        };
      })(),
      r = (function () {
        function t() {}
        return (
          (t.generateVelocity = function () {
            let t = Math.random() - 0.5,
              i = Math.random() + e.CONFIG.y_bias,
              n = Math.sqrt(t * t + i * i);
            return (
              (i /= n),
              new o(
                (t /= n) * (Math.random() * e.CONFIG.explosion_power),
                i * (Math.random() * e.CONFIG.explosion_power),
              )
            );
          }),
          t
        );
      })(),
      s = (function () {
        function t() {}
        return (
          (t.clearScreen = function () {
            e.CTX && e.CTX.clearRect(0, 0, 2 * window.innerWidth, 2 * window.innerHeight);
          }),
          (t.drawRectangle = function (t, i, n, o, r) {
            e.CTX &&
              (e.CTX.save(),
              e.CTX.beginPath(),
              e.CTX.translate(t.x + i.x / 2, t.y + i.y / 2),
              e.CTX.rotate((n * Math.PI) / 180),
              e.CTX.rect(-i.x / 2, -i.y / 2, i.x, i.y),
              (e.CTX.fillStyle = `hsla(${o}deg, 90%, 65%, ${r}%)`),
              e.CTX.fill(),
              e.CTX.restore());
          }),
          t
        );
      })();
    return e;
  })();

  interface ConfettiProps {
    id?: string;
    particleCount?: number;
    explosionPower?: number;
    particleSize?: number;
    fade?: boolean;
    destroyTarget?: boolean;
    yBias?: number;
  }

  const props = withDefaults(defineProps<ConfettiProps>(), {
    id: 'confetti-element',
    particleCount: 75,
    explosionPower: 25,
    particleSize: 1,
    fade: true,
    destroyTarget: true,
    yBias: -0.7,
  });

  const elementRef = ref<HTMLElement>();
  let confettiInstance: any = null;

  const initConfetti = () => {
    if (elementRef.value) {
      elementRef.value.id = props.id;
      nextTick(() => {
        const element = document.getElementById(props.id);
        if (element) {
          confettiInstance = new Confetti(props.id);
          confettiInstance.setCount(props.particleCount);
          confettiInstance.setPower(props.explosionPower);
          confettiInstance.setSize(props.particleSize);
          confettiInstance.setFade(props.fade);
          confettiInstance.destroyTarget(props.destroyTarget);
          confettiInstance.setYBias(props.yBias);
        }
      });
    }
  };

  const triggerConfetti = (x?: number, y?: number) => {
    if (elementRef.value && confettiInstance) {
      if (x !== undefined && y !== undefined) {
        // Create synthetic click event at specific coordinates
        const event = new MouseEvent('click', {
          clientX: x,
          clientY: y,
          bubbles: true,
        });
        elementRef.value.dispatchEvent(event);
      } else {
        // Default to center of screen if no coordinates provided
        const centerX = window.innerWidth / 2;
        const centerY = window.innerHeight / 2;
        const event = new MouseEvent('click', {
          clientX: centerX,
          clientY: centerY,
          bubbles: true,
        });
        elementRef.value.dispatchEvent(event);
      }
    }
  };

  onMounted(() => {
    initConfetti();
  });

  onUnmounted(() => {
    if (confettiInstance?.animationId) {
      cancelAnimationFrame(confettiInstance.animationId);
    }
    const canvas = Confetti.CTX?.canvas;
    if (canvas?.parentNode) {
      canvas.parentNode.removeChild(canvas);
    }
    Confetti.CTX = null;
    confettiInstance = null;
  });

  defineExpose({
    triggerConfetti,
    initConfetti,
    setCount: (count: number) => confettiInstance?.setCount(count),
    setPower: (power: number) => confettiInstance?.setPower(power),
    setSize: (size: number) => confettiInstance?.setSize(size),
    setFade: (fade: boolean) => confettiInstance?.setFade(fade),
    setYBias: (bias: number) => confettiInstance?.setYBias(bias),
  });
</script>

<template>
  <div ref="elementRef" class="confetti-trigger">
    <slot />
  </div>
</template>

<style scoped>
  .confetti-trigger {
    display: inline-block;
    cursor: pointer;
  }
</style>
